import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../components/PageHeader";
import useEditableContent from "../hooks/useEditableContent";

const FALLBACK_DESTINATION_IMGS = [
  "https://images.unsplash.com/photo-1591604129939-f1efa4d9f7fa?w=800&q=80",
  "https://images.unsplash.com/photo-1519817650390-64a93db51149?w=800&q=80",
  "https://images.unsplash.com/photo-1539650116574-8efeb43e2750?w=800&q=80",
  "https://images.unsplash.com/photo-152423+-----1757912-21f4fe3a7200?w=800&q=80",
];

const DestinationsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const destinationDetailsValue = t("destinationDetails", { returnObjects: true });
  const fallbackDestinationDetails = Array.isArray(destinationDetailsValue) ? destinationDetailsValue : [];
  const editableDestinationDetails = useEditableContent("destinations.json", fallbackDestinationDetails);
  const destinationDetails = Array.isArray(editableDestinationDetails) ? editableDestinationDetails : fallbackDestinationDetails;

  return (
    <>
      <style>{`
        .dest-section { padding:60px 60px 80px; background:var(--cream); }
        .dest-detail-card { display:grid; grid-template-columns:1fr 1fr; border-radius:16px; overflow:hidden; margin-bottom:32px; box-shadow:0 8px 30px rgba(0,0,0,0.1); }
        .dest-detail-card:nth-child(even) .dd-img  { order:2; }
        .dest-detail-card:nth-child(even) .dd-body { order:1; }
        .dd-img { height:400px; max-height:400px; aspect-ratio:16/10; overflow:hidden; background:#e7decd; }
        .dd-img img { width:100%; height:100%; object-fit:cover; transition:transform 0.6s; display:block; }
        .dest-detail-card:hover .dd-img img { transform:scale(1.04); }
        .dd-body { background:white; padding:44px; display:flex; flex-direction:column; justify-content:center; }
        .dd-country { color:var(--gold); font-size:12px; letter-spacing:2px; text-transform:uppercase; font-weight:600; margin-bottom:8px; }
        .dd-name { font-family:var(--font-heading); font-size:30px; color:var(--deep); margin-bottom:14px; }
        .dd-desc { font-size:15px; color:var(--text-muted); line-height:1.75; margin-bottom:24px; }
        .dd-highlights { display:flex; flex-wrap:wrap; gap:8px; margin-bottom:28px; }
        .dd-tag { background:rgba(201,168,76,0.1); border:1px solid rgba(201,168,76,0.3); color:var(--gold-dark); font-size:12px; font-weight:600; padding:5px 12px; border-radius:100px; }
        @media(max-width:768px){ .dest-section{padding:40px 20px 60px} .dest-detail-card{grid-template-columns:1fr} .dest-detail-card:nth-child(even) .dd-img{order:0} .dest-detail-card:nth-child(even) .dd-body{order:0} .dd-img{height:240px} .dd-body{padding:24px} }
      `}</style>

      <PageHeader
        tag={t("sections.explore")}
        title={t("nav.destinations")}
        subtitle={t("destinationsPage.subtitle")}
      />

      <div className="dest-section">
        {destinationDetails.map((d, i) => (
          <div key={i} className="dest-detail-card">
            <div className="dd-img">
              <img
                src={d.img || FALLBACK_DESTINATION_IMGS[i]}
                alt={d.name}
                loading="lazy"
                onError={(event) => {
                  if (event.currentTarget.src !== FALLBACK_DESTINATION_IMGS[i]) {
                    event.currentTarget.src = FALLBACK_DESTINATION_IMGS[i];
                  }
                }}
              />
            </div>
            <div className="dd-body">
              <div className="dd-country">{d.flag} {d.country}</div>
              <h3 className="dd-name">{d.name}</h3>
              <p className="dd-desc">{d.desc}</p>
              <div className="dd-highlights">
                {(d.highlights || []).map(h => <span key={h} className="dd-tag">✦ {h}</span>)}
              </div>
              <button className="btn-gold" style={{alignSelf:"flex-start"}} onClick={() => navigate("/packages")}>
                {t("sections.viewAll")} →
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default DestinationsPage;
